var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.78,
    height: 14.78,
    viewBox: "0 0 14.78 14.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search-alt-2",
    "data-name": "search-alt",
    d: "M29.387,29.75a1.344,1.344,0,0,1-1.9,0l-3.234-3.234a6.093,6.093,0,1,1,1.9-1.9l3.234,3.234A1.344,1.344,0,0,1,29.387,29.75Zm-8.34-4.981a3.359,3.359,0,1,0-3.359-3.359A3.359,3.359,0,0,0,21.047,24.769Z",
    transform: "translate(-15 -15.364)",
    fill: "#2328b4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAlt);
export default __webpack_public_path__ + "static/media/search-alt.c73732775871456b774c6b3ee537f77d.svg";
export { ForwardRef as ReactComponent };